var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"inner_ad_div",staticStyle:{"margin-top":"40px"}},[_c('eo-ad-zone',{attrs:{"data-apikey":"TPDM7M9IKdMOwSkFi9lBI2knVhZSQUpYueoZx9Zu","data-format":"desktop"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }